export default "__VITE_PUBLIC_ASSET__33d6e85b__"